var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Floor Price")]),_c('Collections',{attrs:{"search":"/search/findOrderByFloorPrice"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }